import { Component, Input, OnInit } from "@angular/core";
import { UserSessionService } from "src/app/_services/user-session.service";

@Component({
  selector: "app-loading-screen",
  templateUrl: "./loading-screen.component.html",
  styleUrls: ["./loading-screen.component.scss"]
})
export class LoadingScreenComponent {
  @Input() onStartUp: boolean = false;
  constructor() { }
}
